
export const update_areaOption = 'update_areaOption';

export const update_scoreItem = 'update_scoreItem';


export const update_subDomain = 'update_subDomain';